import { useClearSession } from '@/utils/authorization/clear-session'
import { useAuthStore } from '@/stores/auth'
import router from '@/router'
import * as MaCookieStorage from '@/model/MaCookieStorage'
import { RouteName } from '@/base/constants/route'

import { MaNotification } from '@mobileaction/action-kit'

const AUTH_ERROR_CODES = Object.freeze({
  AUTHENTICATION_FAILED: 'AUTHENTICATION_FAILED',
  REFRESH_TOKEN_EXPIRED: 'REFRESH_TOKEN_EXPIRED',
  AUTH_MULTIPLE_LOGIN: 'AUTH_MULTIPLE_LOGIN',
})

function isMultipleLoginError(errors) {
  return errors.some(errorCode => errorCode == AUTH_ERROR_CODES.AUTH_MULTIPLE_LOGIN)
}

function showSessionExpiredWarning(isMultipleLogin = false) {
  const notificationOptions = {
    title: 'Session Expired',
    description: 'Your session has expired, you have been redirected to the login page.',
    size: 'large',
  }

  if (isMultipleLogin) {
    notificationOptions.description = 'Login activity detected from another browser, you have been redirected to the login page.'
  }

  MaNotification.warning(notificationOptions)
}

export function getCookieAuth() {
  return MaCookieStorage.get(MaCookieStorage.COOKIES.AUTH)
}

export function getCurrentAccessToken() {
  const userAuth = getCookieAuth()
  return userAuth?.jwt
}

export function getCurrentRefreshToken() {
  const userAuth = getCookieAuth()
  return userAuth?.refreshToken
}

export function setRefreshedAcccessToken(token) {
  const authStore = useAuthStore()
  authStore.updateJWT(token)
}

export function isAuthError(errors = []) {
  const authErrorCodes = Object.values(AUTH_ERROR_CODES)
  return errors.some(errorCode => authErrorCodes.includes(errorCode))
}

export function logout(errors = []) {
  const { clearSession } = useClearSession()
  clearSession()

  if (router.currentRoute.value.name == RouteName.AUTH_LOGIN)
    return
  showSessionExpiredWarning(isMultipleLoginError(errors))

  router.push({
    name: RouteName.AUTH_LOGIN,
    query: {
      forwardTo: router.currentRoute.value.fullPath,
    },
  })
}
